import React, { useEffect } from 'react';
import { Modal } from './modal';

interface BookingTimeoutDialogProps {
  isOpen: boolean;
  onClose: VoidFunction;
  messages: {
    title: string;
    description: string;
    okButton: string;
  };
}

export const BookingTimeoutDialog: React.FC<BookingTimeoutDialogProps> = ({
  isOpen,
  onClose,
  messages,
}) => {
  // Disable body scroll when open
  useEffect(() => {
    if (isOpen) {
      const bodyWidth = document.body.clientWidth;
      document.body.style.overflow = 'hidden';
      document.body.style.width = `${bodyWidth}px`;
    }
    return () => {
      document.body.style.overflow = 'unset';
      document.body.style.width = 'auto';
    };
  }, [isOpen]);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      shouldCloseOnEscKey={false}
      shouldCloseOnOutsideClick={false}
    >
      <div
        id="booking-timeout-modal"
        className="bg-white px-12 py-8 rounded-xl max-w-[90vw] md:w-[640px] text-center"
      >
        <h2 className="text-center text-xl font-serif text-red-200 mt-8 font-medium">
          {messages.title}
        </h2>
        <p className="mt-2">{messages.description}</p>
        <div className="flex flex-row items-center gap-4 w-full justify-center mt-6">
          <button
            onClick={onClose}
            className="px-6 py-3 text-white text-xs tracking-widest uppercase font-sans font-semibold bg-red-200 -skew-x-12 rounded-md"
          >
            <p className="skew-x-12">{messages.okButton}</p>
          </button>
        </div>
      </div>
    </Modal>
  );
};
